import React from 'react';

import Button from 'components/Button/Button';

import styles from './DetailsFooter.module.scss';

interface Props {
  closeModal: () => void;
  handleConfirm: () => void;
  confirmButton?: string;
  loading?: boolean;
}

const DetailsFooter: React.FC<Props> = ({ closeModal, handleConfirm, confirmButton, loading }) => {
  return (
    <footer className={styles.Footer} data-testid="details-footer">
      <Button onClick={closeModal} level="low">
        <span>Cancel</span>
      </Button>
      <Button onClick={handleConfirm} level="high">
        {loading ? (
          <i className="mm-circle-o-notch mm-spin" />
        ) : (
          <span>{confirmButton ? `${confirmButton}` : 'Publish'}</span>
        )}
      </Button>
    </footer>
  );
};

export default DetailsFooter;
